module.exports = __webpack_public_path__ + "static/media/sliderItem7.e6295578.JPG";